export class SimpleRepairsPerformancesDeleteRequest {
  period!: number

  constructor(period: number) { this.period = period }
}
